// extracted by mini-css-extract-plugin
module.exports = {"cursor":"Cursor_cursor__WLMGR","hidden":"Cursor_hidden__3mrjE"};